export default "__VITE_ASSET__Wwb4oo1u__"